export default __webpack_public_path__ + "static/media/Snd5.c3f2de7c.mp3";